/* Variable collection - Light Mode */
export const lightMode = {
  '--grafite-grafite-10': '#F7F7F6FF',
  '--grafite-grafite-50': '#F0F0EEFF',
  '--grafite-grafite-75': '#E9E9E7FF',
  '--grafite-grafite-100': '#D9D9D9FF',
  '--grafite-grafite-200': '#CCCCCC',
  '--grafite-grafite-300': '#CFCFCFFF',
  '--grafite-grafite-400': '#999999FF',
  '--grafite-grafite-500': '#666666',
  '--grafite-grafite-600': '#4F4F4FFF',
  '--grafite-grafite-meta': '#CFCFCFFF',
  '--grafite-grafite-form-on': '#37322DFF',
  '--grafite-grafite-form-off': '#CCCCCCFF',
  '--grafite-grafite-card': '#37322DFF',

  '--brand---grafite': '#37322DFF',
  '--brand-grafite-grafite-texto': '#37322DFF',
  '--brand---vermelho': '#FF3219FF',
  '--brand---amarelo': '#FFDC00FF',
  '--brand---branco': '#FFFFFFFF',
  '--brand-grafite-grafite-médio': '#3B3836FF',
  '--brand-grafite-grafite-escuro': '#272421FF',
  '--brand-grafite-grafite-background': '#FFFFFFFF',
  '--brand-grafite-grafite-linha-clean': '#D9D9D9FF',
  '--alertas-azul-azul-10': '#F1F6FDFF',
  '--alertas-azul-azul-50': '#E0EDFFFF',
  '--alertas-azul-azul-100': '#0052EAFF',
  '--alertas-verde-verde-10': '#EEFFF3FF',
  '--alertas-verde-verde-50': '#DFF8E6FF',
  '--alertas-verde-verde-75': '#D6EDE1FF',
  '--alertas-verde-verde-90': '#51D88BFF',
  '--alertas-verde-verde-100': '#23A047',
  '--alertas-laranja-laranja-10': '#FFFCF5FF',
  '--alertas-laranja-laranja-50': '#FFFAEBFF',
  '--alertas-laranja-laranja-60': '#FFF6DBFF',
  '--alertas-laranja-laranja-70': '#FEEFDAFF',
  '--alertas-laranja-laranja-100': '#F79009FF',
  '--alertas-vermelho-vermelho-10': '#FFF6F8FF',
  '--alertas-vermelho-vermelho-50': '#FFE4EAFF',
  '--alertas-vermelho-vermelho-100': '#F44336FF',
};
/* Variable collection - Dark Mode */
export const darkMode = {
  '--grafite-grafite-10': '#2D2D2DFF',
  '--grafite-grafite-50': '#292929FF',
  '--grafite-grafite-75': '#212121FF',
  '--grafite-grafite-100': '#D9D9D9FF',
  '--grafite-grafite-200': '#CCCCCCFF',
  '--grafite-grafite-300': '#CFCFCFFF',
  '--grafite-grafite-400': '#999999FF',
  '--grafite-grafite-500': '#666666FF',
  '--grafite-grafite-600': '#4F4F4FFF',
  '--grafite-grafite-meta': '#4A4A4AFF',
  '--grafite-grafite-form-on': '#FFFFFFFF',
  '--grafite-grafite-form-off': '#4A4A4AFF',
  '--grafite-grafite-card': '#605F5EFF',
  '--brand---grafite': '#1E1E1EFF',
  '--brand-grafite-grafite-texto': '#FFFFFFFF',
  '--brand---vermelho': '#FF3219FF',
  '--brand---amarelo': '#FFDC00FF',
  '--brand---branco': '#FFFFFFFF',
  '--brand-grafite-grafite-médio': '#3B3836FF',
  '--brand-grafite-grafite-escuro': '#191919FF',
  '--brand-grafite-grafite-background': '#191919FF',
  '--brand-grafite-grafite-linha-clean': '#4F4F4FFF',
  '--alertas-azul-azul-10': '#20314AFF',
  '--alertas-azul-azul-50': '#1C2B41FF',
  '--alertas-azul-azul-100': '#0052EAFF',
  '--alertas-verde-verde-10': '#102617FF',
  '--alertas-verde-verde-50': '#1F4229FF',
  '--alertas-verde-verde-75': '#1F3E28FF',
  '--alertas-verde-verde-90': '#51D88BFF',
  '--alertas-verde-verde-100': '#23A047',
  '--alertas-laranja-laranja-10': '#432B0FFF',
  '--alertas-laranja-laranja-50': '#2B1E11FF',
  '--alertas-laranja-laranja-60': '#432B0FFF',
  '--alertas-laranja-laranja-70': '#2B1E11FF',
  '--alertas-laranja-laranja-100': '#F79009FF',
  '--alertas-vermelho-vermelho-10': '#2A1414FF',
  '--alertas-vermelho-vermelho-50': '#431918FF',
  '--alertas-vermelho-vermelho-100': '#F44336FF',
};
